import SignInForm from './connected';

export default SignInForm;